import { registerFormInputComponent } from '@vendure/admin-ui/core';
import { SellerPortfolioFormInputComponent } from './input-form.component';

export default [
    registerFormInputComponent(
        'seller-portfolio-form-input',
        SellerPortfolioFormInputComponent
    ),
];
